import { useCallback, useEffect } from 'react';

export const useEscapeClose = (handler: () => void, condition?: boolean) => {
  const escapeListener = useCallback(() => handler(), [handler]);
  useEffect(() => {
    document.addEventListener('keydown', (ev) => {
      if (
        (condition || typeof condition === 'undefined') &&
        ev.key === 'Escape'
      ) {
        escapeListener();
      }
    });
    return () => {
      document.removeEventListener('keydown', escapeListener);
    };
  }, [condition, escapeListener]);
};
